"use client";
// ===================================================
// GAM Command Center — מחברת (Notebook)
// Kept as the public entry point for existing imports (vClick, /dashboard/pinkas).
// v4: the list/detail split with its "חזרה" button is gone — both surfaces
// render the one unified workspace. Spec: docs/specs/pinkas-unified-workspace-20260924.md
// ===================================================
import { PinkasWorkspace, type PinkasWorkspaceProps } from "./PinkasWorkspace";

export type PinkasTableProps = PinkasWorkspaceProps;

export function PinkasTable(props: PinkasTableProps) {
  return <PinkasWorkspace {...props} />;
}
